export default __webpack_public_path__ + "static/media/General.226a2651.png";